import React from 'react';
import '../style/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>Diseñado & Construido por Joaquín Leiva</p>
    </footer>
  );
};

export default Footer;
